import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { ModifierState } from "./types";
import { Modifier as ModifierType } from "@/types";

export const initialState: ModifierState = {
  data: null,
  loading: false,
  error: null,
};

const modifierSlice = createSlice({
  name: "modifier",
  initialState,
  reducers: {
    setModifiers: (
      state: ModifierState,
      action: PayloadAction<ModifierType[]>
    ) => {
      state.data = action.payload;
    },
  },
});

const persistConfig = {
  key: "modifier",
  storage,
  whitelist: ["data"],
};

export const { setModifiers } = modifierSlice.actions;

export const modifierReducer = modifierSlice;
export default persistReducer(persistConfig, modifierSlice.reducer);
